import React, { useState } from "react";
import { createSongType } from "./songTypeApi";

interface AddSongTypeFormData {
  name: string;
  description?: string;
}

const AddSongType: React.FC = () => {
  const [formData, setFormData] = useState<AddSongTypeFormData>({
    name: "",
    description: "",
  });
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);
  const [success, setSuccess] = useState(false);

  const handleInputChange = (
    e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>
  ) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setIsLoading(true);
    setError(null);

    try {
      await createSongType(formData);
      setSuccess(true);
      setFormData({ name: "", description: "" });
    } catch (err: any) {
      setError(err.response?.data?.error || "Failed to create song type");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="add-song-type">
      <h2>Add Song Type</h2>

      {error && <div className="error-message">{error}</div>}
      {success && (
        <div className="success-message">Song type created successfully!</div>
      )}

      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="name">Type Name *</label>
          <input
            type="text"
            id="name"
            name="name"
            value={formData.name}
            onChange={handleInputChange}
            required
            disabled={isLoading}
          />
        </div>

        <div className="form-group">
          <label htmlFor="description">Description</label>
          <textarea
            id="description"
            name="description"
            value={formData.description}
            onChange={handleInputChange}
            disabled={isLoading}
            rows={4}
          />
        </div>

        <div className="form-actions">
          <button type="submit" disabled={isLoading}>
            {isLoading ? "Creating..." : "Create Song Type"}
          </button>
        </div>
      </form>
    </div>
  );
};

export default AddSongType;
